import React from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const SizeLegendLabel = () => {
  const [state] = useProductDetailsPageContext();

  const legendLabel = ({ abbreviatedLabel, fullLabel }) => {
    return (
      <>
        <Text height="short" family="medium" scale="3">
          {abbreviatedLabel}
        </Text>{' '}
        <Text height="short" family="regular" scale="3">
          {fullLabel}
        </Text>
      </>
    );
  };

  const petiteLegendLabel = legendLabel({
    abbreviatedLabel: 'P',
    fullLabel: '= Petite',
  });

  const plusLegendLabel = legendLabel({
    abbreviatedLabel: '1X-3X',
    fullLabel: '= Plus',
  });

  const shortLegendLabel = legendLabel({
    abbreviatedLabel: 'SH',
    fullLabel: '= Short',
  });

  const tallLegendLabel = legendLabel({
    abbreviatedLabel: 'TA',
    fullLabel: '= Tall',
  });

  if (state.sizesIncludePetite && state.sizesIncludePlus) {
    return (
      <Box mb={0.75} mt={0.5}>
        <Text height="short" family="regular" scale="3">
          {petiteLegendLabel} | {plusLegendLabel}
        </Text>
      </Box>
    );
  }

  if (state.sizesIncludeShort && state.sizesIncludeTall) {
    return (
      <Box mb={0.75} mt={0.5}>
        <Text height="short" family="regular" scale="3">
          {shortLegendLabel} | {tallLegendLabel}
        </Text>
      </Box>
    );
  }

  if (state.sizesIncludePetite) {
    return (
      <Box mb={0.75} mt={0.5}>
        {petiteLegendLabel}
      </Box>
    );
  }

  if (state.sizesIncludePlus) {
    return (
      <Box mb={0.75} mt={0.5}>
        {plusLegendLabel}
      </Box>
    );
  }

  if (state.sizesIncludeShort) {
    return (
      <Box mb={0.75} mt={0.5}>
        {shortLegendLabel}
      </Box>
    );
  }

  if (state.sizesIncludeTall) {
    return (
      <Box mb={0.75} mt={0.5}>
        {tallLegendLabel}
      </Box>
    );
  }

  return null;
};

export default SizeLegendLabel;
